import React, { Component } from 'react';
import { graphql } from 'gatsby';
import { Layout, PostcardForm } from '../components';
import { PackageListItem } from '../components/Packages';
import './packages.scss';

class PackagesPage extends Component {
  render() {
    const {
      data: {
        page: {
          data: pageData,
        },
      },
      location,
    } = this.props;
    const {
      packages,
      metaTitle,
      metaDescription,
      openGraphImage,
    } = pageData;
    const seoData = {
      metaTitle,
      metaDescription,
      openGraphImage,
    };
    return (
      <Layout location={location} seoData={seoData}>
        <section className="packages">
          {packages && packages.map(packageItem => (
            <PackageListItem key={packageItem.packageType.text} {...packageItem} />
          ))}
          <PostcardForm
            title="Get in touch"
            formName="contact-form-packages"
          />
        </section>
      </Layout>
    );
  }
}

export default PackagesPage;

export const pageQuery = graphql`
  query PackagesPageQuery {
    site {
      siteMetadata {
        storiesSlug,
      }
    },
    page: prismicPackages {
      uid,
      data {
        packages {
          packageType: package_type {
            html
            text
          }
          startingPrice: starting_price {
            html
            text
          }
          details {
            html
            text
          }
          # testimonials {
          #   html
          #   text
          # }
          featuredImage: featured_image {
            alt
            localFile {
              childImageSharp {
                fluid(maxWidth: 1000, quality: 90) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
        metaTitle: meta_title {
          html
          text
        },
        metaDescription: meta_description {
          html
          text
        },
        openGraphImage: open_graph_image {
          alt
          copyright
          url
        }
      }
    }
  }
`;
